module.exports = __webpack_public_path__ + "img/10_fineTeam_ts.3240c843.png";